import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { rtbPlatformList } from 'constants/resources/commonCustomize';
import { showSuccessSnackbar } from 'modules/snackbar';
import { setPortal } from 'modules/portal';
import { userOnLogin } from 'lib/api/user';

import CurrentStatus from 'components/atoms/CurrentStatus';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics';
import IssueStatistics from './IssueStatistics';
import FluctuationStatistics from './FluctuationStatistics';
import DetailStatistics from './DetailStatistics';
import AmtCompareStatistics from './AmtCompareStatistics';
import SectionCompareStatistics from './SectionCompareStatistics';
import Budget from './Budget';
import Unpaid from './Unpaid';
import Dormancy from './Dormancy';
import Kpi from './Kpi';

const AdvertiserStatistics = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  let { path } = useRouteMatch();

  const { menu, common, portal, allProductCodeList } = useSelector(
    ({ menu, allProductCodeList, common, portal }) => ({
      menu: menu.list === null ? new Map() : menu.list,
      portal: portal,
      common: common,
      allProductCodeList: common.allProductCodeList,
    })
  );

  const [readyFlag, setReadyFlag] = useState(false);

  useEffect(() => {
    setReadyFlag(common.productCodeList.size > 0);
    // eslint-disable-next-line
  }, [common.productCodeList]);

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const handleOnLogin = (ADVER_ID) => {
    userOnLogin(ADVER_ID, 'manage')
      .then((response) => {
        const { data, success } = response.data;
        if (success) {
          handlePortalUrl(data.url);
        } else {
          handleClickSnackbar({
            message: t('로그인에 실패했습니다. 관리자에게 문의하세요.'),
            option: { type: 'error' },
          });
        }
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <MainTemplate>
      {readyFlag ? (
        <MbTabs
          name="AdvertiserStatistics"
          tabMenuList={tabList()}
          tabs={{
            '/report/adver/issue': {
              tabComponent: (
                <IssueStatistics
                  handleClickSnackbar={handleClickSnackbar}
                  handleOnLogin={handleOnLogin}
                />
              ),
            },
            '/report/adver/statistics': {
              tabComponent: (
                <Statistics
                  portal={portal}
                  storeCommon={common}
                  storeAllProductCodeList={allProductCodeList}
                  rtbDayPlatformList={rtbPlatformList}
                />
              ),
            },
            '/report/adver/budget': {
              tabComponent: (
                <Budget
                  handleClickSnackbar={handleClickSnackbar}
                  handlePortalUrl={handlePortalUrl}
                  handleOnLogin={handleOnLogin}
                />
              ),
            },
            '/report/adver/fluctuation': {
              tabComponent: (
                <FluctuationStatistics
                  handleClickSnackbar={handleClickSnackbar}
                  handlePortalUrl={handlePortalUrl}
                  handleOnLogin={handleOnLogin}
                />
              ),
            },
            '/report/adver/unpaid': {
              tabComponent: <Unpaid />,
            },
            '/report/adver/dormancy': {
              tabComponent: <Dormancy />,
            },
            '/report/adver/kpi': {
              tabComponent: <Kpi />,
            },
            '/report/adver/detail': {
              tabComponent: (
                <DetailStatistics
                  handlePortalUrl={handlePortalUrl}
                  storeCommon={common}
                  storeAllProductCodeList={allProductCodeList}
                  rtbDayPlatformList={rtbPlatformList}
                />
              ),
              isPop: 1,
            },
            '/report/adver/compare': {
              tabComponent: <AmtCompareStatistics />,
              isPop: 1,
            },
            '/report/adver/sectionCompare': {
              tabComponent: <SectionCompareStatistics />,
              isPop: 1,
            },
          }}
          isModal={false}
        />
      ) : (
        <CurrentStatus type="loading" option="useMinHeight" />
      )}
    </MainTemplate>
  );
};

export default AdvertiserStatistics;
